export enum UserAccountStatus {
    AccountInitiated = "Account Initiated",
    AccountInitiatedAndInvited = "Account Initiated & Invited",
    AccountActivated = "Account Activated",
    AccountDeactivated = "Account Deactivated",
}